import React, { FC } from 'react'

import { IconAccelerometerLowProps } from './IconAccelerometerLow.types'
import * as Styled from './styles/IconAccelerometerLow.style'

import { nonThemeableRules } from '../../ruleSet'

const IconAccelerometerLow: FC<IconAccelerometerLowProps> = ({
  size = nonThemeableRules.defaultSize as number as IconAccelerometerLowProps['size'],
  isResponsive = false,
}: IconAccelerometerLowProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M42.953 24.074c0 10.496-8.504 19-19 19-10.492 0-19-8.504-19-19 0-10.492 8.508-19 19-19h19v19Z'
          stroke='#fff'
          strokeWidth='2'
        />
        <path d='M23.953 9.227v2.91' stroke='#fff' strokeLinecap='round' strokeWidth='2' />
        <path d='m13.426 13.61 10.539 10.538' stroke='#EA1A1A' strokeLinecap='round' strokeWidth='2' />
        <path d='M38.871 24.172h-2.914M34.54 13.637l-2.06 2.062M9.102 24.074h2.914' stroke='#fff' strokeLinecap='round' strokeWidth='2' />
        <path d='M25.074 24.074a1.12 1.12 0 0 1-2.238 0 1.12 1.12 0 0 1 2.238 0Z' stroke='#EA1A1A' strokeLinecap='round' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconAccelerometerLow
